//auth Action Types
// Create
export const TRANSACTION_CREATION_STARTED = "TRANSACTION_CREATION_STARTED";
export const TRANSACTION_CREATION_SUCCESS = "TRANSACTION_CREATION_SUCCESS";
export const TRANSACTION_CREATION_FAILED = "TRANSACTION_CREATION_FAILED";

//Fetch
export const TRANSACTION_FETCH_STARTED = "TRANSACTION_FETCH_STARTED";
export const TRANSACTION_FETCH_SUCCESS = "TRANSACTION_FETCH_SUCCESS";
export const TRANSACTION_FETCH_FAILED = "TRANSACTION_FETCH_FAILED";

//Update
export const TRANSACTION_UPDATE_STARTED = "TRANSACTION_UPDATE_STARTED";
export const TRANSACTION_UPDATE_SUCCESS = "TRANSACTION_UPDATE_SUCCESS";
export const TRANSACTION_UPDATE_FAILED = "TRANSACTION_UPDATE_FAILED";

//Delete
export const TRANSACTION_DELETE_STARTED = "TRANSACTION_DELETE_STARTED";
export const TRANSACTION_DELETE_SUCCESS = "TRANSACTION_DELETE_SUCCESS";
export const TRANSACTION_DELETE_FAILED = "TRANSACTION_DELETE_FAILED";
